<template>
  <div class="page-popup">
    <div
      v-show="isActive"
      class="popup-wrap performance"
      :class="{ active: isActive }"
    >
      <div class="popup-box">
        <div class="popup-page">
          <!--eslint-disable-next-line -->
          <p class="h5 nl2br" v-html="limitText" />
        </div>
        <a class="popup-close" @click="hideModel" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PerformanceModal',
  props: {
    isActive: Boolean,
    limitText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    hideModel() {
      this.$emit('hideModel')
    }
  }
}
</script>

